import request from '@aned/request';

// 网点预到达查询
export async function getSitePlan(params) {
  return request('/api/route/getSitePlan', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 干线预到达查询
export async function getTrunkLinePlan(params) {
  return request('/api/route/getTrunkLinePlan', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 库存货量查询（包含优势在库数据）
export async function getRepertory(params) {
  return request('/api/route/getRepertory', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 出发货量日均查询
export async function departWeightDisperse(params) {
  return request('/api/route/departWeightDisperse', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 已装未发
export async function loadedNotSent(params) {
  return request('/api/route/getLoadNoSend', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

//在库3300
export async function inStock3300(params) {
  return request('/api/route/getRepertory3300', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
// 执行所有API请求并处理错误
export async function fetchAllData(params) {
  // /api/route/getSitePlan  网点预到达查询
  // /api/route/getTrunkLinePlan  干线预到达查询
  // /api/route/getRepertory  库存货量查询（包含优势在库数据）
  // /api/route/departWeightDisperse  出发货量日均查询
  // /api/route/getLoadNoSend  已装未发
  // /api/route/getSitePlanVolumes  公司运力
  const requests = [
    getSitePlan(params),
    getTrunkLinePlan(params),
    getRepertory(params),
    departWeightDisperse(params),
    loadedNotSent(params),
    inStock3300(params),
    getSitePlanVolumes(params),
    getSitePlanDistance(params),
  ];

  // 使用 Promise.allSettled 来处理所有请求并捕获错误
  const results = await Promise.allSettled(requests);

  // 将每个请求结果进行解析并处理成功和失败的情况
  const processedResults = results.map((result) => {
    if (result.status === 'fulfilled') {
      return result?.value?.data || [];
    } else {
      console.error('Request failed:', result.reason);
      return []; // 如果请求失败，返回 [] 或其他占位符
    }
  });

  return processedResults;
}

// // 示例合并函数（可以根据业务需求传入不同的合并逻辑）
// function mergeResults(resultsArray) {
//   // 将成功的数据合并为一个对象或数组
//   return resultsArray.reduce((acc, result) => {
//     if (result) {
//       acc = { ...acc, ...result };  // 假设每个结果都是对象并合并它们
//     }
//     return acc;
//   }, {});
// }

// // 使用示例
// async function getDataAndMerge(params) {
//   const data = await fetchAllData(params);
//   const mergedData = mergeResults(data);

//   console.log('Merged Data:', mergedData);
//   return mergedData;
// }

/**
 * 区域流向查询
 * @param {*} params
 * @returns
 */
export async function selectAreaAirBurst(params) {
  return request('/api/route/selectAreaAirBurst', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

/**
 * 区域流向查询
 * @param {*} params
 * @returns
 */
export async function selectSrForecastByDetail(params) {
  return request('/api/route/selectSrForecastByDetail', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function exportTrunkLineArrivalDetail(params) {
  return request('/api/route/exportTrunkLineArrivalDetail', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

export async function exportRepertoryDetail(params) {
  return request('/api/route/exportRepertoryDetail', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

export async function getPlanTime(params){
  return request('/api/route/getPlanTime', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function selectByParentCode(params){
    return request('/api/preferencePub/selectByKey', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function getSitePlanVolumes(params){
  return request('/api/route/getSitePlanVolumes', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function getSitePlanCounty(params){
  return request('/api/route/getSitePlanCounty', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function getSitePlanDistance(params){
  return request('/api/route/getSitePlanDistance', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function getSitePlanClassityAreaName(params){
    return request('/api/route/getSitePlanClassityAreaName', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}
